'use strict';

/**
 * @author Maxim Seredkin
 * @return {*}
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/project-filter-indicator.html'),
        scope: {
            filters: '=myModel',
            filter: '=myFilter',
        },
        controller: [function() {
            
        }],
    };
}
